import { useContext } from 'react'

import { CustomerContext } from '../context/CustomerProvider'


const useCustomer = () => {
    const customer = useContext(CustomerContext)

    if (!customer) {
        throw new Error('App customer is not set')
    }

    return customer
}

export {
    useCustomer,
}
